import { useSEO, SOCIAL_IMAGE } from '@/hooks/useSEO';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import CommunityHero from './components/CommunityHero';
import ConnectButtons from './components/ConnectButtons';
import CommunityForms from './components/CommunityForms';
import CommunityCTA from './components/CommunityCTA';

export default function CommunityPage() {
  useSEO({
    title: 'CSCF Community | Connect with Families Affected by Cardiospondylocarpofacial Syndrome',
    description:
      'Join the CSCF Support community. Connect with families, caregivers, and researchers affected by Cardiospondylocarpofacial syndrome. Share your story and find support.',
    keywords:
      'CSCF community, Cardiospondylocarpofacial syndrome families, CSCF support group, rare disease community, CSCF caregivers, share CSCF story',
    canonical: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/community`,
    ogImage: SOCIAL_IMAGE,
    breadcrumbs: [
      { name: 'Home', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
      { name: 'Community', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/community` },
    ],
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'CSCF Community — Connect with Families Affected by Cardiospondylocarpofacial Syndrome',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/community`,
        description:
          'Join the CSCF Support community. Connect with families, caregivers, and researchers affected by Cardiospondylocarpofacial syndrome. Share your story and find support.',
        isPartOf: { '@type': 'WebSite', name: 'CSCF Support', url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/` },
        about: {
          '@type': 'MedicalCondition',
          name: 'Cardiospondylocarpofacial Syndrome',
          alternateName: ['CSCF', 'CSCFS'],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'CSCF Support Community',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/community`,
        description:
          'A peer support community for families, caregivers, and individuals affected by Cardiospondylocarpofacial syndrome (CSCF), a rare genetic condition caused by MAP3K7 gene variants.',
        memberOf: {
          '@type': 'Organization',
          name: 'CSCF Support',
          url: `${import.meta.env.VITE_SITE_URL ?? 'https://cscfsupport.org'}/`,
        },
        sameAs: ['https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP'],
        knowsAbout: [
          'Cardiospondylocarpofacial Syndrome',
          'CSCF rare disease support',
          'MAP3K7 gene variants',
          'rare disease family support',
        ],
      },
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CommunityHero />
      <ConnectButtons />
      <CommunityForms />
      <CommunityCTA />
      <Footer />
    </div>
  );
}
